import { NgModule } from '@angular/core'
import { DataHomeHeadComponent } from '@components/data-home-head/data-home-head.component'

@NgModule({
  declarations: [DataHomeHeadComponent],
  exports: [DataHomeHeadComponent],
  imports: [],
})
export class DataHomeHeadModule {}
